module.exports = __webpack_public_path__ + "media/images/homes/retail_pos-7f894625b3d27d0330ae94b5e319d8cb.svg";